import React from "react";
import Navbar from "../common/navbar";
import { Container, Button, Alert, Spinner } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import authService from "../../services/authService";
import { useUser } from "../../context/UserContext";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      emailValid: false,
      showGoBack: false,
      showPassword: false,
      rememberMe: false,
      loading: false,
      error: "",
    };
  }

  componentDidMount() {
    const rememberedEmail = localStorage.getItem("rememberedEmail");
    const rememberedPassword = localStorage.getItem("rememberedPassword");
    if (rememberedEmail && rememberedPassword) {
      this.setState({
        email: rememberedEmail,
        password: rememberedPassword,
        emailValid: true,
        showGoBack: true,
        rememberMe: true,
      });
    }
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState(
      {
        [name]: value,
      },
      () => {
        if (name === "email") {
          this.validateEmail(value);
        }
        if (name === "password" && value) {
          this.setState({ showGoBack: true });
        }
      }
    );
  };

  validateEmail = (email) => {
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    this.setState({ emailValid, showGoBack: emailValid });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true, error: "" });
    try {
      const userData = await authService.login(
        this.state.email,
        this.state.password
      );
      this.props.login(userData); // Set user data in context
      if (this.state.rememberMe) {
        localStorage.setItem("rememberedEmail", this.state.email);
        localStorage.setItem("rememberedPassword", this.state.password);
      } else {
        localStorage.removeItem("rememberedEmail");
        localStorage.removeItem("rememberedPassword");
      }
      this.props.login(userData); // Update user context
      this.props.navigate(
        userData.isSetupComplete ? "/overview" : "/guided_setup"
      ); // Redirect based on setup status
    } catch (error) {
      this.setState({
        error: "Incorrect email or password. Please check and try again",
        loading: false,
      });
    }
  };

  handleGoBack = () => {
    this.setState({
      email: "",
      password: "",
      emailValid: false,
      showGoBack: false,
    });
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  handleRememberMeChange = (event) => {
    this.setState({ rememberMe: event.target.checked });
  };

  render() {
    const { state } = this.props.location;
    const successMessage = state?.successMessage;

    return (
      <div className="body-font">
        <Navbar hideNavLinks={true} /> {/* Pass hideNavLinks as true */}
        <Container className="text-center empty-space-mt w-lg-25">
          <h1 className="text-nowrap fs-five-title my-4 d-flex justify-content-center align-items-center">
            Log in into{" "}
            <div className="mx-1 purple-color mb-0 fs-5 righteousy-font">
              <span className="fs-3">Nouraa</span>
              <span className="fs-two">.ai</span>
            </div>{" "}
            Account
          </h1>
          {successMessage && (
            <Alert variant="success" className="w-100 w-md-50 w-lg-25 mx-auto">
              {successMessage}
            </Alert>
          )}
          <p className="gray-color">
            Don't have an account?{" "}
            <a
              className="purple-color text-decoration-none fw-bold"
              href="/signup"
            >
              Sign up
            </a>
          </p>
          <form onSubmit={this.handleSubmit} className="login-form my-4">
            <div className="form-group mb-4">
              <label className="text-start w-100 w-md-50 w-lg-25 mb-1 fw-bold gray-color">
                Email
              </label>
              <input
                type="text"
                name="email"
                value={this.state.email}
                placeholder="Enter your email"
                onChange={this.handleInputChange}
                className="form-control w-100 w-md-50 w-lg-25 mx-auto"
              />
              {!this.state.emailValid && this.state.email && (
                <small className="text-danger d-block text-start mt-1">
                  Invalid email address
                </small>
              )}
            </div>
            {this.state.emailValid && (
              <>
                <div className="form-group mb-4 position-relative">
                  <label className="text-start w-100 w-md-50 w-lg-25 mb-1 fw-bold gray-color">
                    Password
                  </label>
                  <input
                    type={this.state.showPassword ? "text" : "password"}
                    name="password"
                    value={this.state.password}
                    placeholder="Enter your password"
                    onChange={this.handleInputChange}
                    className="form-control w-100 w-md-50 w-lg-25 mx-auto"
                  />
                  {this.state.password && (
                    <span
                      onClick={this.togglePasswordVisibility}
                      className="position-absolute top-50 end-0  me-3"
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={
                          this.state.showPassword
                            ? "/assets/eye-slash.svg"
                            : "/assets/eye.svg"
                        }
                        alt="Toggle visibility"
                      />
                    </span>
                  )}
                </div>
                <div className="form-group mb-4 d-flex justify-content-between w-100 w-md-50 w-lg-25 mx-auto">
                  <div>
                    <input
                      type="checkbox"
                      id="rememberMe"
                      checked={this.state.rememberMe}
                      onChange={this.handleRememberMeChange}
                    />
                    <label htmlFor="rememberMe" className="ms-2">
                      Remember for 30 days
                    </label>
                  </div>
                  <Link
                    to="/forgot-password"
                    className="purple-color text-decoration-none fw-bold"
                  >
                    Forgot password?
                  </Link>
                </div>
              </>
            )}
            {this.state.error && (
              <p className="text-danger w-100 w-md-50 w-lg-25 mx-auto">
                {this.state.error}
              </p>
            )}
            <Button
              className="btn-primary-style fs-one fw-bold w-100 w-md-50 w-lg-25"
              type="submit"
              disabled={!this.state.emailValid || this.state.loading}
            >
              {this.state.loading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "Log in"
              )}
            </Button>
          </form>
          {this.state.showGoBack && (
            <button
              onClick={this.handleGoBack}
              className="purple-color text-decoration-none fw-bold btn btn-link"
            >
              Go Back
            </button>
          )}
          {!this.state.emailValid && (
            <div className="or-login-container">
              <div className="d-flex align-items-center my-4 w-100 w-md-50 w-lg-25 mx-auto">
                <hr className="flex-grow-1" />
                <span className="mx-2 gray-color">OR</span>
                <hr className="flex-grow-1" />
              </div>
              <div className="d-flex flex-column align-items-center">
                <Button className="btn-google w-100 w-md-50 w-lg-25 mb-2 bg-white black-color fw-bold border-secondary-subtle">
                  <img
                    src="/assets/Social icon.svg"
                    alt="Google"
                    className="me-2"
                  />
                  Continue with Google
                </Button>
                <Button className="btn-facebook w-100 w-md-50 w-lg-25 mb-2 bg-white black-color fw-bold border-secondary-subtle">
                  <img
                    src="/assets/Social-icon1.svg"
                    alt="Facebook"
                    className="me-2"
                  />
                  Continue with Facebook
                </Button>
                <Button className="btn-apple w-100 w-md-50 w-lg-25 bg-white black-color fw-bold border-secondary-subtle">
                  <img
                    src="/assets/Social-icon2.svg"
                    alt="Apple"
                    className="me-2"
                  />
                  Continue with Apple
                </Button>
              </div>
            </div>
          )}
        </Container>
      </div>
    );
  }
}

const LoginWithNavigate = (props) => {
  const location = useLocation();
  const { login } = useUser();
  return (
    <Login
      {...props}
      navigate={useNavigate()}
      location={location}
      login={login}
    />
  );
};

export default LoginWithNavigate;
